import AppCard from '../../components/apps/AppCard';
import PageMeta from '../../components/common/PageMeta';

// Interface para as integrações
interface Integration {
    imageUrl: string;
    title: string;
    description: string;
    status: 'active' | 'not_connected';
    to: string;
}

// Interface para categorias de integrações
interface IntegrationCategory {
    name: string;
    integrations: Integration[];
}

export default function AppsPageView() {
    // Configuração de categorias e integrações
    const INTEGRATION_CATEGORIES: IntegrationCategory[] = [
        {
            name: 'Infraestrutura',
            integrations: [
                {
                    imageUrl: '/images/integration/domain-icon.svg',
                    title: 'Domínios',
                    description: 'Gerencie seus domínios',
                    status: 'not_connected',
                    to: '/apps/domains',
                },
                {
                    imageUrl: '/images/integration/connector-icon.svg',
                    title: 'Webhooks',
                    description: 'Gerencie seus Webhooks',
                    status: 'not_connected',
                    to: '/apps/webhooks',
                },
            ],
        },
        {
            name: 'Área de Membros',
            integrations: [
                {
                    imageUrl: '/images/logo/logo-icon.svg',
                    title: 'Sellyo Members',
                    description: 'Área de Membros',
                    status: 'not_connected',
                    to: '/apps/sellyo-members',
                },
                {
                    imageUrl: '/images/integration/cademi-icon.svg',
                    title: 'Cademí',
                    description: 'Área de Membros',
                    status: 'not_connected',
                    to: '/apps/cademi',
                },
                {
                    imageUrl: '/images/integration/tm-icon.svg',
                    title: 'TheMembers',
                    description: 'Área de Membros',
                    status: 'not_connected',
                    to: '/apps/themembers',
                },
                {
                    imageUrl: '/images/integration/astronmembers-icon.svg',
                    title: 'AstronMembers',
                    description: 'Área de Membros',
                    status: 'not_connected',
                    to: '/apps/astronmembers',
                },
                /*{
                    imageUrl: '/images/integration/curseduca-icon.png',
                    title: 'Curseduca',
                    description: 'Área de Membros',
                    status: 'not_connected',
                    to: '/apps/curseduca',
                },
                {
                    imageUrl: '/images/integration/memberkit-dark-icon.webp',
                    title: 'Memberkit',
                    description: 'Área de Membros',
                    status: 'not_connected',
                    to: '/apps/memberkit',
                },*/
            ],
        },
        {
            name: 'Trackeamento',
            integrations: [
                {
                    imageUrl: '/images/integration/utmify-icon.png',
                    title: 'Utmify',
                    description: 'Trackeamento',
                    status: 'not_connected',
                    to: '/apps/utmify',
                },
            ],
        },
        {
            name: 'Emissor de Nota',
            integrations: [
                {
                    imageUrl: '/images/integration/notazz-icon.png',
                    title: 'Notazz',
                    description: 'Emissor de notas',
                    status: 'not_connected',
                    to: '/apps/notazz',
                },
                {
                    imageUrl: '/images/integration/spedy.avif',
                    title: 'Spedy',
                    description: 'Emissor de notas',
                    status: 'not_connected',
                    to: '/apps/spedy',
                },
            ],
        },
        /*{
            name: 'API',
            integrations: [
                {
                    imageUrl: '/images/integration/shell-icon.svg',
                    title: 'API',
                    description: 'Gerencie suas credenciais API',
                    status: 'not_connected',
                    to: '/apps/api',
                },
            ],
        },*/
    ];

    return (
        <div className="pt-2 pb-4">
            <PageMeta
                title="Sellyo - Integrações"
                description="Gerenciar integrações"
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12 mb-6">
                    <div className="flex justify-between items-center">
                        <div className="w-auto">
                            <h3 className="text-lg font-semibold text-gray-800 dark:text-white/90">
                                Integrações
                            </h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Renderizar categorias e suas integrações */}
            <div className="space-y-8">
                {INTEGRATION_CATEGORIES.map((category) => (
                    <div key={category.name}>
                        {/* Título da categoria */}
                        <h4 className="text-base font-medium text-gray-700 dark:text-white/80 mb-4">
                            {category.name}
                        </h4>

                        {/* Grid de integrações da categoria */}
                        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                            {category.integrations.map((integration) => (
                                <AppCard
                                    key={integration.title}
                                    imageUrl={integration.imageUrl}
                                    title={integration.title}
                                    description={integration.description}
                                    status={integration.status}
                                    to={integration.to}
                                />
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}